import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const voidTransaction = ({ transactionId }: { transactionId: number }) => {

  const params = {
    transaction_id: transactionId,
  };

  return axiosPrivate.post(`/dashboard/api/v1/void`, params);
};